import { render, staticRenderFns } from "./TheQnaAccordionTr.vue?vue&type=template&id=21b85a3a&scoped=true&"
import script from "./TheQnaAccordionTr.vue?vue&type=script&lang=js&"
export * from "./TheQnaAccordionTr.vue?vue&type=script&lang=js&"
import style0 from "./TheQnaAccordionTr.vue?vue&type=style&index=0&id=21b85a3a&prod&module=true&lang=css&"
import style1 from "./TheQnaAccordionTr.vue?vue&type=style&index=1&id=21b85a3a&prod&scoped=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "21b85a3a",
  null
  
)

export default component.exports